import M_role from '@/models/role';
const {
  dashboard,
  parentDashboard,
  broadcast,
  acts,
  alert,
  task,
  taskTemplate,
  contractor,
  license,
  training,
  event,
  contractorEnterRecord,
  audit,
  checklist,
  commonChoice,
  changeManagement,
  memberManagement,
  roleManagement,
  factoryManagement,
  sosRequest,
  app,
  factoryTag,
  factoryEffect,
  qrcode,
  file,
  agent,
  guideline,
  guidelineAdmin,
  translation,
  meeting,
  meetingTemplate,
  factorySystemClass,
  log,
} = M_role.fields;
export default {
  modelName: 'role_type',
  label: '角色類別管理',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '角色名稱',
          rules: 'required',
        },
      },
    },
    name: {
      type: 'text',
      label: '角色名稱',
      rules: 'required',
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    has_factory_system: {
      type: 'switch',
      defaultValue: true,
      activeText: '需要',
      inactiveText: '不需要',
    },
    has_factory_scope: {
      type: 'switch',
      defaultValue: true,
      activeText: '需要',
      inactiveText: '不需要',
    },
    dashboard,
    parentDashboard,
    broadcast,
    acts,
    alert,
    task,
    taskTemplate,
    contractor,
    license,
    training,
    event,
    contractorEnterRecord,
    audit,
    checklist,
    commonChoice,
    changeManagement,
    memberManagement,
    roleManagement,
    factoryManagement,
    sosRequest,
    app,
    factoryTag,
    factoryEffect,
    qrcode,
    file,
    agent,
    guideline,
    guidelineAdmin,
    translation,
    meeting,
    meetingTemplate,
    factorySystemClass,
    log,
  },
};
